import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tipo-impresion',
  templateUrl: './tipo-impresion.component.html',
  styleUrls: ['./tipo-impresion.component.scss']
})
export class TipoImpresionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/productos/tipo-impresion/tipo-impresion.component.ts